import { makeAutoObservable } from 'mobx'

class GlobalSearchUIStore {
   private _isGlobalSearchModalOpen!: boolean

   private constructor() {
      this.init()

      makeAutoObservable(this, {}, { autoBind: true })
   }

   private init(): void {
      this._isGlobalSearchModalOpen = false
   }

   // #region GlobalSearchModal
   get isGlobalSearchModalOpen(): boolean {
      return this._isGlobalSearchModalOpen
   }

   closeGlobalSearchModal(): void {
      this._isGlobalSearchModalOpen = false
   }

   setGlobalSearchModalOpen(): void {
      this._isGlobalSearchModalOpen = true
   }
   // #endregion

   static createGlobalSearchUIStore = (): GlobalSearchUIStore =>
      new GlobalSearchUIStore()
}

export default GlobalSearchUIStore
